import { useLoaderData } from "react-router-dom";
import { Profile } from "../../shared/components/profile";
import { User } from "../../shared/types/user";

export const UserPage: React.FC = () => {
  const data = useLoaderData();
  return <Profile user={data as User} />;
};
